import { usePlaceholderHook } from "@/hooks/use-placeholder.hook.ts";
import { CssLoader } from "@/ui/shared/CssLoader.tsx";
import { Image, ImageProps, LoadingOverlay, Paper } from "@mantine/core";
import { cva } from "class-variance-authority";
import { HTMLAttributes, memo, useState } from "react";

export const LoadingImage = memo(function LoadingImage(
  props: ImageProps & HTMLAttributes<HTMLImageElement>,
) {
  const [isLoading, setIsLoading] = useState(true);
  const placeholder = usePlaceholderHook();
  const classes = cva(["object-contain", "my-auto"], {
    variants: {
      hasOnClick: {
        true: ["cursor-pointer"],
        false: [],
      },
      isLoading: {
        true: ["hidden"],
        false: ["block"],
      },
    },
  });

  return (
    <>
      {!props.src && (
        <Paper
          withBorder={true}
          className="relative rounded-lg overflow-hidden"
          w="100%"
          h="100%"
          style={{ minHeight: 100 }}
        >
          <Image className="z-[2]" src={placeholder} />
          <LoadingOverlay
            visible={true}
            zIndex={5}
            overlayProps={{ radius: "sm", blur: 2 }}
            loaderProps={{
              color: "pink",
              type: "custom",
              children: <CssLoader />,
            }}
          />
        </Paper>
      )}
      {props.src && (
        <Paper withBorder={true} className="overflow-hidden">
          {isLoading && <Image src={placeholder} />}
          <div className="flex h-full w-full">
            <img
              className={classes({
                hasOnClick: Boolean(props.onClick),
                isLoading,
              })}
              alt="AI Photo"
              src={props.src}
              onClick={props.onClick}
              onLoad={() => setIsLoading(false)}
            />
          </div>
        </Paper>
      )}
    </>
  );
});
